import { defineAsyncComponent, hydrateOnVisible } from 'vue'

import ParagraphTypeChildTagsTeaserGroup from '../teaser/ChildTagsTeaserGroup.vue'
import ParagraphTypeInlineTeaser from '../teaser/InlineTeaser.vue'
import ParagraphTypeTeaserGroup from '../teaser/TeaserGroup.vue'
import ParagraphTypeAdaAdSlot from '../ad-slots/AdaAdSlot.vue'
import AdaSlotMarker from '../ad-slots/AdaSlotMarker.vue'
import ParagraphTypeAdaNativeCrossbar from '../ad-slots/AdaNativeCrossbar.vue'
import ParagraphTypeAdaAutoNative from '../ad-slots/AdaAutoNative.vue'
import ParagraphTypeAdaPagestrip from '../ad-slots/AdaPagestrip.vue'
import ParagraphTypeAdditionalLinks from './ParagraphTypeAdditionalLinks.vue'
import ParagraphTypeAffiliateLink from './ParagraphTypeAffiliateLink.vue'
import ParagraphTypeAuthorBox from './ParagraphTypeAuthorBox.vue'
import ParagraphTypeButtonGroup from './ParagraphTypeButtonGroup.vue'
import ParagraphTypeContentBox from './ParagraphTypeContentBox.vue'
import ParagraphTypeDummyContainer from './ParagraphTypeDummyContainer.vue'
import ParagraphTypeEmbed from './ParagraphTypeEmbed.vue'
import ParagraphTypeFaq from './ParagraphTypeFaq.vue'
import ParagraphTypeHorizontalLine from './ParagraphTypeHorizontalLine.vue'
import ParagraphTypeHotOrNot from './ParagraphTypeHotOrNot.vue'
import ParagraphTypeHtml from './ParagraphTypeHtml.vue'
import ParagraphTypeIframe from './ParagraphTypeIframe/EmbedWrapper.vue'
import ParagraphTypeImage from './ParagraphTypeImage.vue'
import ParagraphTypeInterline from './ParagraphTypeInterline.vue'
import ParagraphTypeLexicon from './ParagraphTypeLexicon.vue'
import ParagraphTypeListOfSources from './ParagraphTypeListOfSources.vue'
import ParagraphTypeNewsletterTeaser from './ParagraphTypeNewsletterTeaser.vue'
import ParagraphTypeParagraphCollection from './ParagraphTypeParagraphCollection.vue'
import ParagraphTypeProductGroup from './ParagraphTypeProductGroup.vue'
import ParagraphTypeRecipe from './ParagraphTypeRecipe/RecipeWrapper.vue'
import ParagraphTypeRelatedTags from './ParagraphTypeRelatedTags.vue'
import ParagraphTypeSearch from './ParagraphTypeSearch.vue'
import ParagraphTypeSlider from './ParagraphTypeSlider.vue'
import ParagraphTypeSocialStrip from './ParagraphTypeSocialStrip.vue'
import ParagraphTypeStructureTermTree from './ParagraphTypeStructureTermTree.vue'
import ParagraphTypeTable from './ParagraphTypeTable.vue'
import ParagraphTypeTableExt from './ParagraphTypeTableExt.vue'
import ParagraphTypeTableOfContents from './ParagraphTypeTableOfContents.vue'
import ParagraphTypeTagList from './ParagraphTypeTagList.vue'
import ParagraphTypeVideo from './ParagraphTypeVideo.vue'
import ParagraphTypeProductAutoComparison from './ParagraphTypeProductAutoComparison.vue'
import ParagraphTypeInfoBar from './ParagraphTypeInfoBar.vue'
import ParagraphTypeEpgChannelSlider from './ParagraphTypeEpgChannelSlider.vue'
import ParagraphTypeEpgWidget from './ParagraphTypeEpgWidget.vue'
import ParagraphTypeVodTeaserForEpgBroadcast from './ParagraphTypeVodTeaserForEpgBroadcast.vue'
import ParagraphTypeAdDividingLine from './ParagraphTypeAdDividingLine.vue'
import ParagraphTypeTabbedInfo from './ParagraphTypeTabbedInfo.vue'
import ParagraphTypeVodEpgBroadcastSlider from './ParagraphTypeVodEpgBroadcastSlider.vue'

// Async paragraph types
const ParagraphTypeAdviceWidget = asyncParagraphType('AdviceWidget')
const ParagraphTypeAscendantCalculator = asyncParagraphType('AscendantCalculator')
const ParagraphTypeContactForm = asyncParagraphType('ContactForm')
const ParagraphTypeEpgBroadcastRating = asyncParagraphType('EpgBroadcastRating')
const ParagraphTypeFileDownload = asyncParagraphType('FileDownload')
const ParagraphTypeHoroscope = asyncParagraphType('Horoscope')
const ParagraphTypeMoonRun = asyncParagraphType('MoonRun')
const ParagraphTypePoll = asyncParagraphType('Poll')
const ParagraphTypeQuiz = asyncParagraphType('Quiz')
const ParagraphTypeQuote = asyncParagraphType('Quote')
const ParagraphTypeVodRating = asyncParagraphType('VodRating')
const ParagraphTypeVodStreamingOptions = asyncParagraphType('VodStreamingOptions')
const ParagraphTypeVodSeasonWithEpisodes = asyncParagraphType('VodSeasonWithEpisodes')
const ParagraphTypeWebForm = asyncParagraphType('WebForm')

// Async components
const ParagraphTypeConsentRevokeButton = asyncParagraphType('ConsentRevokeButton', true)
const ParagraphTypeUserActivation = asyncParagraphType('UserActivation', true)
const ParagraphTypeUserPasswordChange = asyncParagraphType('UserPasswordChange', true)
const ParagraphTypeUserPasswordReset = asyncParagraphType('UserPasswordReset', true)
const ParagraphTypeUserLogin = asyncParagraphType('UserLogin', true)
const ParagraphTypeUserRegister = asyncParagraphType('UserRegister', true)
const ParagraphTypeUserSubscription = asyncParagraphType('UserSubscription', true)

function asyncParagraphType (name, component = false) {
  return defineAsyncComponent({
    loader: () => component ? import(`./ParagraphTypeVueComponent/${name}.vue`) : import(`./ParagraphType${name}.vue`),
    hydrate: hydrateOnVisible()
  })
}

export {
  ParagraphTypeHtml,
  ParagraphTypeInterline,
  ParagraphTypeImage,
  ParagraphTypeQuote,
  ParagraphTypeSlider,
  ParagraphTypeSocialStrip,
  ParagraphTypeVideo,
  ParagraphTypeWebForm,
  ParagraphTypeQuiz,
  ParagraphTypeAdaNativeCrossbar,
  ParagraphTypeAdaAdSlot,
  ParagraphTypeAdaAutoNative,
  ParagraphTypeAdaPagestrip,
  ParagraphTypeEmbed,
  ParagraphTypeFaq,
  ParagraphTypeIframe,
  ParagraphTypeHorizontalLine,
  ParagraphTypeParagraphCollection,
  ParagraphTypeRelatedTags,
  ParagraphTypeTagList,
  ParagraphTypeDummyContainer,
  ParagraphTypeInlineTeaser,
  ParagraphTypeTeaserGroup,
  ParagraphTypeChildTagsTeaserGroup,
  ParagraphTypeStructureTermTree,
  ParagraphTypeAuthorBox,
  ParagraphTypeContentBox,
  ParagraphTypeAdviceWidget,
  ParagraphTypeAffiliateLink,
  ParagraphTypeAdditionalLinks,
  ParagraphTypeListOfSources,
  ParagraphTypeMoonRun,
  ParagraphTypeTable,
  ParagraphTypeTableExt,
  ParagraphTypeTableOfContents,
  ParagraphTypeHotOrNot,
  ParagraphTypePoll,
  ParagraphTypeNewsletterTeaser,
  ParagraphTypeAscendantCalculator,
  ParagraphTypeHoroscope,
  ParagraphTypeButtonGroup,
  ParagraphTypeFileDownload,
  ParagraphTypeProductGroup,
  ParagraphTypeLexicon,
  ParagraphTypeSearch,
  ParagraphTypeContactForm,
  ParagraphTypeConsentRevokeButton,
  ParagraphTypeUserRegister,
  ParagraphTypeUserLogin,
  ParagraphTypeUserActivation,
  ParagraphTypeUserPasswordReset,
  ParagraphTypeUserPasswordChange,
  ParagraphTypeUserSubscription,
  ParagraphTypeRecipe,
  ParagraphTypeProductAutoComparison,
  ParagraphTypeInfoBar,
  ParagraphTypeVodRating,
  ParagraphTypeVodStreamingOptions,
  ParagraphTypeVodSeasonWithEpisodes,
  ParagraphTypeEpgBroadcastRating,
  ParagraphTypeEpgChannelSlider,
  ParagraphTypeEpgWidget,
  ParagraphTypeVodTeaserForEpgBroadcast,
  ParagraphTypeAdDividingLine,
  ParagraphTypeTabbedInfo,
  ParagraphTypeVodEpgBroadcastSlider,
  AdaSlotMarker
}

export default {
  ParagraphTypeHtml,
  ParagraphTypeInterline,
  ParagraphTypeImage,
  ParagraphTypeQuote,
  ParagraphTypeSlider,
  ParagraphTypeVideo,
  ParagraphTypeWebForm,
  ParagraphTypeQuiz,
  ParagraphTypeAdaNativeCrossbar,
  ParagraphTypeAdaAdSlot,
  ParagraphTypeAdaAutoNative,
  ParagraphTypeAdaPagestrip,
  ParagraphTypeEmbed,
  ParagraphTypeFaq,
  ParagraphTypeIframe,
  ParagraphTypeHorizontalLine,
  ParagraphTypeParagraphCollection,
  ParagraphTypeRelatedTags,
  ParagraphTypeTagList,
  ParagraphTypeDummyContainer,
  ParagraphTypeInlineTeaser,
  ParagraphTypeTeaserGroup,
  ParagraphTypeChildTagsTeaserGroup,
  ParagraphTypeStructureTermTree,
  ParagraphTypeAuthorBox,
  ParagraphTypeContentBox,
  ParagraphTypeAdviceWidget,
  ParagraphTypeAffiliateLink,
  ParagraphTypeAdditionalLinks,
  ParagraphTypeListOfSources,
  ParagraphTypeMoonRun,
  ParagraphTypeTable,
  ParagraphTypeTableExt,
  ParagraphTypeTableOfContents,
  ParagraphTypeHotOrNot,
  ParagraphTypePoll,
  ParagraphTypeNewsletterTeaser,
  ParagraphTypeAscendantCalculator,
  ParagraphTypeHoroscope,
  ParagraphTypeButtonGroup,
  ParagraphTypeFileDownload,
  ParagraphTypeProductGroup,
  ParagraphTypeLexicon,
  ParagraphTypeSearch,
  ParagraphTypeContactForm,
  ParagraphTypeConsentRevokeButton,
  ParagraphTypeUserRegister,
  ParagraphTypeUserLogin,
  ParagraphTypeUserActivation,
  ParagraphTypeUserPasswordReset,
  ParagraphTypeUserPasswordChange,
  ParagraphTypeUserSubscription,
  ParagraphTypeRecipe,
  ParagraphTypeProductAutoComparison,
  ParagraphTypeInfoBar,
  ParagraphTypeVodRating,
  ParagraphTypeVodStreamingOptions,
  ParagraphTypeVodSeasonWithEpisodes,
  ParagraphTypeEpgBroadcastRating,
  ParagraphTypeEpgChannelSlider,
  ParagraphTypeEpgWidget,
  ParagraphTypeVodTeaserForEpgBroadcast,
  ParagraphTypeAdDividingLine,
  ParagraphTypeTabbedInfo,
  ParagraphTypeVodEpgBroadcastSlider,
  AdaSlotMarker
}
